import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Accordion, Col, FormGroup, Row, Pagination } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useOutletContext } from "react-router-dom";
import { Input, Label } from "reactstrap";
import { getUserRedeems, getUserReferrals, putProfile, sendReferralMail } from "store/actions";
import toastr from "toastr";
import { PaginationItem, PaginationLink } from "reactstrap";
import { validUrl, validate } from "helpers/validations";
import { Oval } from 'react-loader-spinner'
import Privadoqr from "Pages/Privadosc/Privadoqr";

export default function Setting() {
  const [menu, menuopen] = useOutletContext();
  const { user } = useSelector((s) => s?.Login)
  // const userLoading = useSelector((s) => s?.Login)
  const { referrals, loading } = useSelector((s) => s?.Referrals)
  const { redeems } = useSelector((s) => s?.Referrals)
  const [copied, setCopied] = useState(false)
  const dispatch = useDispatch()
  const [userReferralCode, setReferralCode] = useState()
  const [isFieldCHanged, setIsFieldChanged] = useState(true)
  const [inviteButton, setinviteButton] = useState(false) 
  const [fields, setFields] = useState({
    name: "",
    email: ""
  })
  const [timezone, setTimezone] = useState()
  const {
    name,
    nameError,
    email,
    emailError
  } = fields;


  const [socailMediaFields, setSocailMediaFields] = useState({ facebookUrl: "", youtubeUrl: "", instagramUrl: "", discordUrl: "", telegramUrl: "" })
  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString)
  }, [])

  useEffect(() => {
    // setSocailMediaFields({
    //   facebookUrl:user?.facebookUrl,
    //   youtubeUrl:user?.youtubeUrl,
    // })


    setSocailMediaFields((prevState) => ({
      ...prevState,
      youtubeUrl: user?.youtubeUrl,
      instagramUrl: user?.instagramUrl,
      facebookUrl: user?.facebookUrl,
      discordUrl: user?.discordUrl,
      telegramUrl: user?.telegramUrl,
    }))
  }, [user])
  useEffect(() => {
    setReferralCode(user?.referral_code)
    if (user?._id) {
      let data = {}
      data.user_id = user?._id
      dispatch(getUserReferrals(data))
      dispatch(getUserRedeems(data))
    }
  }, [user, dispatch])

  useEffect(() => { if (copied) { toastr.success("Referral Code Copied") && setCopied(!copied) } }, [copied])
  useEffect(() => {
    menu(false)
  }, [menu])

  const onChangeHandler = (e, name) => {
    setinviteButton(false)
    const value = e.target.value

    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );
  }


  const socialMdiaChangeHandler = (e, name) => {
    setIsFieldChanged(false)
    const value = e.target.value
    setSocailMediaFields((prev) =>
      ({ ...prev, [name]: value })
    )
  }

  const sendInvitation = (e) => {
    e.preventDefault();
    let response = validate(fields);
    setFields((prev) => ({ ...prev, ...response }));
    if (!fields?.name) {
      return toastr.error("Name is Required")
    }
    if (!fields?.email) {
      return toastr.error("Email is Required")
    }
    if (userReferralCode && user) {
      let data = {}
      data.name = fields?.name
      data.to = fields?.email
      data.from = user?.email
      data.sender_name = user?.name + " " + user?.lastname

      data.referral_code = userReferralCode
      const referralEmailCallback = (res) => {
        if (res.status === "success") {
          setinviteButton(true)
          toastr.success("Invitaion sent Successfully")
        }else{
          toastr.error(res.message)
          return
        }
        setFields({
          name: "",
          email: ""
        });
      }
      dispatch(sendReferralMail(data, referralEmailCallback))
    } else {
      return toastr.error("You do not have any referral")
    }
  }





  const updateSocailMedia = () => {
    if (socailMediaFields?.facebookUrl) {
      if (!validUrl(socailMediaFields?.facebookUrl)) {
        return toastr.error("Invalid Facebook Url")
      }
    }
    if (socailMediaFields?.discordUrl) {
      if (!validUrl(socailMediaFields?.discordUrl)) {
        return toastr.error("Invalid Discord Url")
      }
    }
    if (socailMediaFields?.youtubeUrl) {
      if (!validUrl(socailMediaFields?.youtubeUrl)) {
        return toastr.error("Invalid Youtube Url")
      }
    }
    if (socailMediaFields?.telegramUrl) {
      if (!validUrl(socailMediaFields?.telegramUrl)) {
        return toastr.error("Invalid Telegram Url")
      }
    }
    if (socailMediaFields?.instagramUrl) {
      if (!validUrl(socailMediaFields?.instagramUrl)) {
        return toastr.error("Invalid Instagram Url")
      }
    }
    const callback = (res) => {
      if (res.status === "success") {
        setIsFieldChanged(true)
        toastr.success("Social media updated Successfully")
      }
    }
    dispatch(putProfile(socailMediaFields, callback));
  }


  const handleCopyToClipboard = async (inputText) => {
    try {
      await navigator.clipboard.writeText(inputText);
      setCopied(true);

    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    var x = 0;
    if (referrals?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(referrals.length / 10);
    }
    for (let i = 1; i <= x; i++) {
      if (!dataLength.includes(i)) {
        dataLength.push(i);
      }
    }
  }, [referrals]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (referrals[i]) {
        arr.push(referrals[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, referrals]);

  const handlePagination = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = parseInt(values) - 10;
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < referrals.length) {
      // setSNovalue(referrals.length)
      valu = Math.ceil(referrals.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };


  // pagination for redeem
  const [dataLength2, setDataLength2] = useState([]);
  const [dataAfterPagination2, setDataAfterPagination2] = useState([]);
  var [values2, setValues2] = useState(10);
  var [sNoValue2, setSNovalue2] = useState(0);
  useEffect(() => {
    var x = 0;
    if (redeems?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(redeems.length / 10);
    }
    for (let i = 1; i <= x; i++) {
      if (!dataLength2.includes(i)) {
        dataLength2.push(i);
      }
    }
  }, [redeems]);

  useEffect(() => {
    let arr = [];
    setSNovalue2(values2 - 10);
    for (let i = values2 - 10; i < values2; i++) {
      if (redeems[i]) {
        arr.push(redeems[i]);
      }
    }
    setDataAfterPagination2(arr);
  }, [values2, redeems]);


  const handlePagination2 = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = parseInt(values2) - 10;
    } else if (val === ">" && sNoValue2 / 10 < values2) {
      valu = (parseInt(values2 / 10) + 1) * 10;
    } else if (val === ">>" && values2 < redeems.length) {
      // setSNovalue(redeems.length)
      valu = Math.ceil(redeems.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues2(valu);
  };
const [OpenPrivado, setOpenPrivado] = useState(false)
  const Privado = () => {
    setOpenPrivado(!OpenPrivado)
  }
  return (
    <>
      {loading &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0"><i onClick={menuopen} className="fa-light fa-bars-sort"></i>  Settings</h1>
          </div>
        </Col>
        <Col lg={12} className="mb-4">
          <div className="accordion-faq accordionNew accordingSetting">
            <Accordion defaultActiveKey="0">
              <Accordion.Item>
                <Accordion.Header>Social Media</Accordion.Header>
                <Accordion.Body>
                  <FormGroup className="mb-4">
                    <Label className="fw-semibold">Facebook</Label>
                    <div className="position-relative">
                      <Input type="text" className="ps-5" value={socailMediaFields?.facebookUrl} onChange={(e) => socialMdiaChangeHandler(e, "facebookUrl")} />
                      <div className="btn position-absolute shadow-none border-0 start-0 top-0 p-2 h-full">
                        <img
                          src="/images/svg/facebookIcon.svg"
                          alt=""
                          width={29}
                        />
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label className="fw-semibold">Instagram</Label>
                    <div className="position-relative">
                      <Input type="text" className="ps-5" value={socailMediaFields?.instagramUrl} onChange={(e) => socialMdiaChangeHandler(e, "instagramUrl")} />
                      <div className="btn position-absolute shadow-none border-0 start-0 top-0 p-2 h-full">
                        <img
                          src="/images/svg/instagramIcon.svg"
                          alt=""
                          width={29}
                        />
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label className="fw-semibold">Youtube</Label>
                    <div className="position-relative">
                      <Input type="text" className="ps-5" value={socailMediaFields?.youtubeUrl} onChange={(e) => socialMdiaChangeHandler(e, "youtubeUrl")} />
                      <div className="btn position-absolute shadow-none border-0 start-0 top-0 p-2 h-full">
                        <img
                          src="/images/svg/youtubeIcon.svg"
                          alt=""
                          width={29}
                        />
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label className="fw-semibold">Discord</Label>
                    <div className="position-relative">
                      <Input type="text" className="ps-5" value={socailMediaFields?.discordUrl} onChange={(e) => socialMdiaChangeHandler(e, "discordUrl")} />
                      <div className="btn position-absolute shadow-none border-0 start-0 top-0 p-2 h-full">
                        <img
                          src="/images/svg/facebookIcon.svg"
                          alt=""
                          width={29}
                        />
                      </div>
                    </div>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label className="fw-semibold">Telegram</Label>
                    <div className="position-relative">
                      <Input type="text" className="ps-5" value={socailMediaFields?.telegramUrl} onChange={(e) => socialMdiaChangeHandler(e, "telegramUrl")} />
                      <div className="btn position-absolute shadow-none border-0 start-0 top-0 p-2 h-full">
                        <img
                          src="/images/svg/facebookIcon.svg"
                          alt=""
                          width={29}
                        />
                      </div>
                    </div>
                  </FormGroup>
                  <button
                    type="submit"
                    className="btn btn-dark px-5"
                    onClick={updateSocailMedia}
                    disabled={isFieldCHanged}
                  >
                    Save Changes{" "}

                  </button>
                  {/* <FormGroup className="mb-4">
                    <Label className="fw-semibold">Email Subscription</Label>
                    <div className="SwitchCustome mb-3">
                      <div className="switchCus  ">
                        <Input type="checkbox" id="emailsubs" />
                        <Label
                          htmlFor="emailsubs"
                          className="cursor-pointer"
                        ></Label>
                      </div>
                    </div>
                    <p>
                      <b>Disable email notification.</b> (You will not receive
                      ANY emails Mintable if you do this - including important
                      ones related to your account security or purchases)
                    </p>
                  </FormGroup> */}

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>






            <Accordion defaultActiveKey="0">
              <Accordion.Item>
                <Accordion.Header>Notification</Accordion.Header>
                <Accordion.Body>

                  <div className="GeneralSetting">
                    <FormGroup className="emailNotification">
                      <Label className="fw-semibold">Email Subscription</Label>
                      <div className="SwitchCustome mb-3">
                        <div className="switchCus  ">
                          <Input type="checkbox" id="emailsubs" />
                          <Label
                            htmlFor="emailsubs"
                            className="cursor-pointer"
                            invalid={nameError}
                          ></Label>
                        </div>
                      </div>
                      <p>
                        <b>Disable email notification.</b> (You will not receive
                        ANY emails Mintable if you do this - including important
                        ones related to your account security or purchases)
                      </p>
                    </FormGroup>
                    <table>
                      <tr>
                        <td>
                          <b>Marketing Updates</b> <br /> Once disabled you will not be
                          able to receive marketing notifications (email, app
                          push and on-site inbox notifications)
                        </td>
                        <td>
                          <i className="fa-sharp fa-solid fa-circle-check text-success"></i> On
                        </td>
                        <td>
                          <button>Enable</button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Notification Language</b> <br />Select your preferred language for email app push and on-site inbox notifications</td>
                        <td>
                          <i className="fa-sharp fa-solid fa-circle-check text-success"></i> English(India)
                        </td>
                        <td>
                          <button>Manage</button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion defaultActiveKey="1">
              <Accordion.Item>
                <Accordion.Header>Refer a friend to earn special rewards.</Accordion.Header>
                <Accordion.Body>
                  <div className="refrallBox">
                    <div className="mb-4">
                      <h2>Invite your friends</h2>
                      <h3>Refer a friend to Terpnash and you'll both receive a 7% discount on your next artwork sale/purchase.</h3>
                      <h4>Enter your friends' email address and invite them to join Terpnash.</h4>
                      <div className="sendInviteBox">
                        <FormGroup className="form-group">
                          <Input className="form-control" placeholder="Enter Name" onChange={(e) => onChangeHandler(e, "name")} invalid={nameError} value={fields?.name} />
                        </FormGroup>
                        <FormGroup className="form-group">
                          <Input className="form-control" placeholder="Enter e-mail address" onChange={(e) => onChangeHandler(e, "email")} invalid={emailError} value={fields?.email} />
                        </FormGroup>
                        <button className="btn sendBtn" disabled={inviteButton} onClick={(e) => sendInvitation(e) }>Invite</button>
                      </div>
                    </div>
                    <div className="mb-4">
                      <h2>Referral code</h2>
                      <h4>You can share your referral code by copying and sending it to others or sharing it on your social media.</h4>
                      <div className="sendInviteBox">
                        <FormGroup className="form-group position-relative">
                          <Input className="form-control pe-5" disabled value={user?.referral_code} />
                          <button onClick={() => handleCopyToClipboard(user?.referral_code)} className="btn position-absolute end-0 top-0 bottom-0 my-auto py-0"><img src="/images/svg/copyImg.svg" width={30} alt="" /></button>
                        </FormGroup>
                      </div>
                    </div>
                    <div className="mb-4">
                      <h2>Your Rewards</h2>
                      <div className="childAccordian">
                        <Accordion defaultActiveKey="0">
                          <Accordion.Item>
                            <Accordion.Header> Earned Discount: {user?.earned_discount} Remaining Discount: {user?.referral_count}</Accordion.Header>
                            <Accordion.Body>
                              <div className="table-responsive reffta tableNft mt-0">
                                <table>
                                  <thead>
                                    <tr>
                                      <td>No.</td>
                                      <td>Username</td>
                                      <td>Email</td>
                                      <td>Onboard Date</td>
                                    </tr>
                                  </thead>
                                  {<tbody>
                                    {dataAfterPagination.length > 0 ? (
                                      <>
                                        {dataAfterPagination && dataAfterPagination.map((item, index) =>
                                          <tr>
                                            <td className="text-center">{sNoValue += 1}</td>
                                            <td>{item?.to?.name + " " + item?.to?.lastname} </td>
                                            <td>{item?.to?.email}</td>
                                            <td>{new Date(item?.created_date).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timezone: timezone })}
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <tr>
                                          <td className="text-center text-dark py-4" colSpan={4}>
                                            You’ve not invited any friend yet
                                          </td>
                                        </tr>
                                      </>
                                    )}

                                  </tbody>}
                                  {/* <tbody>
                                    <tr>
                                      <td className="text-center text-dark py-4" colSpan={4}>
                                        You’ve have not invite any friend yet
                                      </td>
                                    </tr>
                                  </tbody> */}








                                </table>
                                <Col lg={12} className="text-end">
                                  <Pagination className="paginationNew" aria-label="Page  navigation example">
                                    {values > 10 &&
                                      <div className="d-flex align-items-center gap-2">
                                        <PaginationItem >
                                          <PaginationLink
                                            first
                                            href="#"
                                            onClick={() => handlePagination("<<")}
                                          />
                                        </PaginationItem>
                                        <PaginationItem >
                                          <PaginationLink
                                            href="#"
                                            previous
                                            onClick={() => handlePagination("<")}
                                          />
                                        </PaginationItem>
                                      </div>
                                    }
                                    {dataAfterPagination.length > 0 && dataLength.map((item) =>
                                      <PaginationItem className={parseInt(item) === (values / 10) ? "active" : ""}>
                                        <PaginationLink href="#" onClick={() => handlePagination(item)}>
                                          {item}
                                        </PaginationLink>
                                      </PaginationItem>
                                    )}
                                    {values < referrals.length &&
                                      <div className="d-flex">
                                        <PaginationItem>
                                          <PaginationLink
                                            href="#"
                                            next
                                            onClick={() => handlePagination(">")}
                                          />
                                        </PaginationItem>
                                        <PaginationItem>
                                          <PaginationLink
                                            href="#"
                                            last
                                            onClick={() => handlePagination(">>")}
                                          />
                                        </PaginationItem>
                                      </div>
                                    }
                                  </Pagination>
                                </Col>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                        <Accordion defaultActiveKey="1">
                          <Accordion.Item>
                            <Accordion.Header>Redeem History - {dataAfterPagination2.length > 0 ? (dataAfterPagination2?.length) : 0}</Accordion.Header>
                            <Accordion.Body>
                              <div className="table-responsive reffta tableNft mt-0">
                                <table>
                                  <thead>
                                    <tr>
                                      <td>No.</td>
                                      <td>Event</td>
                                      <td>Artwork Name</td>
                                      <td>Original Price</td>
                                      <td>Discounted Price</td>
                                      <td>Date</td>

                                    </tr>
                                  </thead>
                                  {<tbody>
                                    {dataAfterPagination2.length > 0 ? (
                                      <>
                                        {dataAfterPagination2 && dataAfterPagination2.map((item, index) =>
                                          <tr>
                                            <td className="text-center">{sNoValue2 += 1}</td>
                                            <td>{item?.transaction_id?.seller_id === user?._id ? "Sale" : "Buy"} </td>
                                            <td>{item?.sellItem?.nft_id?.name}</td>
                                            <td>{(item?.original_price * item?.copies).toFixed(6)} POL</td>
                                            <td>
                                              {(
                                                (item?.seller_discount === true && item?.seller_id === user?._id)
                                                  ? ((item?.original_price * 0.87) * item?.copies).toFixed(6)
                                                  : (item?.seller_discount === false && item?.seller_id === user?._id) ? ((item?.original_price * 0.80) * item?.copies).toFixed(6) : item?.buyer_discount === true && item?.buyer_id === user?._id ? ((item?.original_price * 0.93) * item?.copies).toFixed(6) : (item?.original_price * item?.copies).toFixed(6)
                                              )} POL
                                              {/* <br />
                                              {(
                                                (item?.buyer_discount === true && item?.buyer_id === user?._id)
                                                  ? ((item?.original_price * 0.93) * item?.copies).toFixed(6)
                                                  : (item?.original_price * item?.copies).toFixed(6)
                                              )} MATIC */}
                                            </td>
                                            <td>{new Date(item?.created_date).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timezone: timezone })}
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <tr>
                                          <td className="text-center text-dark py-4" colSpan={8}>
                                            No Data Available
                                          </td>
                                        </tr>
                                      </>
                                    )}

                                  </tbody>}
                                </table>
                                <Col lg={12} className="text-end">
                                  <Pagination className="paginationNew" aria-label="Page  navigation example">
                                    {values > 10 &&
                                      <div className="d-flex align-items-center gap-2">
                                        <PaginationItem >
                                          <PaginationLink
                                            first
                                            href="#"
                                            onClick={() => handlePagination2("<<")}
                                          />
                                        </PaginationItem>
                                        <PaginationItem >
                                          <PaginationLink
                                            href="#"
                                            previous
                                            onClick={() => handlePagination2("<")}
                                          />
                                        </PaginationItem>
                                      </div>
                                    }
                                    {dataAfterPagination2.length > 0 && dataLength2.map((item) =>
                                      <PaginationItem className={parseInt(item) === (values / 10) ? "active" : ""}>
                                        <PaginationLink href="#" onClick={() => handlePagination2(item)}>
                                          {item}
                                        </PaginationLink>
                                      </PaginationItem>
                                    )}
                                    {values < redeems.length &&
                                      <div className="d-flex">
                                        <PaginationItem>
                                          <PaginationLink
                                            href="#"
                                            next
                                            onClick={() => handlePagination2(">")}
                                          />
                                        </PaginationItem>
                                        <PaginationItem>
                                          <PaginationLink
                                            href="#"
                                            last
                                            onClick={() => handlePagination2(">>")}
                                          />
                                        </PaginationItem>
                                      </div>
                                    }
                                  </Pagination>
                                </Col>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>

                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey="2">
              <Accordion.Item>
                <Accordion.Header>Setup Privado ID</Accordion.Header>
                <Accordion.Body className="pt-0">

                  <div className="GeneralSetting">
                  <div className="logginbtns justify-content-start ">
                  <button type="button" onClick={Privado}  className="btn prevadobtn">Connect Privado iD <span><img src="../../images/svg/prevadoIcon.svg"/></span></button>
                </div>           
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Col>
      </Row >
      {OpenPrivado == true &&  <div className="barcodeBoxMaine barcodeafterlogin">
        <Privadoqr func={Privado} />
       
    </div> }
    </>
  );
}